import { render, staticRenderFns } from "./LabelTileList.vue?vue&type=template&id=1d6245c1&"
import script from "./LabelTileList.vue?vue&type=script&lang=js&"
export * from "./LabelTileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports